import React from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import {Link} from "react-router-dom";
  import {useNavigate} from 'react-router-dom'
  
import '../cssfiles/Login.css'
import { Firebase } from '../components/config';
import { useForm ,Controller} from "react-hook-form";
import { useState } from 'react';
import ButtonExample from '../components/loadsubmit'
import '../cssfiles/animation.css'

function Login() {
  const [loading, setLoading] = useState(false)
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      checkbox: false,
    }
  });


  const navigate = useNavigate()

   const onSubmit = (data) =>{
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 3000)
    const Email = data.email
    const Password = data.password
    Firebase.auth().signInWithEmailAndPassword(Email, Password).then(()=>{
      (navigate('/'))
    }).catch((error) => {
      
        alert(error.message)
      
    })
    reset()}
    
            
  
  return (
    <div className="area" >
            <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                
            </ul>  
    <div className='position'>
        
        <Form className="forms" onSubmit={ handleSubmit(onSubmit)}><div className='centertext'><h1>LOGIN</h1><h4 className="text-muted" >OR</h4> <Nav.Link as={Link} to = {'/Signup'} id="hi" className='sign rounded'>SIGN UP</Nav.Link></div>
          <Form.Group className="mb-3 " controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" placeholder="Enter email" className={`form-control ${errors.email && "invalid"}`}
            {...register("email", {
              required: "Email is Required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              }
            })}
            onKeyUp={() => {
              trigger("email");
            }} />
           <div> {errors.email && (
            <small className="text-danger">{errors.email.message}</small>
          )}</div>
            
          </Form.Group>
    
          <Form.Group className="mb-3 " controlId="formBasicPassword ">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" placeholder="Password" className={`form-control ${errors.password && "invalid"}`}
            {...register("password", {
              required: "Password is Required",
              pattern: {
                value: /^.*(?=.{6,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!&$%&?@ "]).*$/,
                message: "Invalid password",
              },maxLength: {
                value: 12,
                message: "Maximum allowed length is 12 ",
              }
            })}
            onKeyUp={() => {
              trigger("password");
            }}/>
            {errors.password && (
            <small className="text-danger">{errors.password.message}</small>
          )}
          </Form.Group>
          <Form.Group className={`form-control ${errors.checkbox && "invalid"}`} controlId="formBasicCheckbox ">
        <Controller name="checkbox"
        control={control}
        rules={{ required: "checkbox is Required"}}
        render={({ field }) => <Form.Check type="checkbox" label="Agree to terms and conditions" {...field} />}
        
        />{errors.checkbox && (
          <small className="text-danger">{errors.checkbox.message}</small>
        )}
        </Form.Group>
        { loading ? <ButtonExample/>
        :<Button variant="dark" type='submit'>
          SUBMIT
        </Button>}
        </Form>
        

       
      </div></div>
  )
}

export default Login